import objectHash from 'object-hash';

/**
 * @template {any} T
 */
export class ResponseCache {

	/**
	 * @type {Map<string, T>}
	 */
	cache = new Map();

	/**
	 * @param {any} body
	 * @returns {string}
	 */
	#getKey (body) {
		return objectHash(body);
	}

	/**
	 * @param {any} body
	 * @param {T} response
	 */
	set (body, response) {
		const hash = this.#getKey(body);

		this.cache.set(hash, response);
	}

	/**
	 * @param {any} body
	 */
	get (body) {
		const hash = this.#getKey(body);

		return this.cache.get(hash);
	}
};
